var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertsButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#E38E3F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0869 19.8162L20.5925 11.7126C20.0148 10.6697 18.96 10.0469 17.7726 10.0469C16.5852 10.0469 15.5303 10.6697 14.9526 11.7126L10.4582 19.8162C9.89514 20.8344 9.90742 22.038 10.4951 23.0414C11.0802 24.0447 12.1227 24.6428 13.2783 24.6428H22.267C23.425 24.6428 24.4651 24.0447 25.0502 23.0414C25.6354 22.0381 25.6502 20.8319 25.0871 19.8187L25.0869 19.8162ZM16.7891 13.8406C16.7891 13.2944 17.2292 12.852 17.7726 12.852C18.3159 12.852 18.756 13.2944 18.756 13.8406V18.5065C18.756 19.0526 18.3159 19.4951 17.7726 19.4951C17.2292 19.4951 16.7891 19.0526 16.7891 18.5065V13.8406ZM17.7726 22.3322C17.2071 22.3322 16.7449 21.8676 16.7449 21.2992C16.7449 20.7308 17.2047 20.2662 17.7726 20.2662C18.3405 20.2662 18.8002 20.7308 18.8002 21.2992C18.8002 21.8676 18.338 22.3322 17.7726 22.3322Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertsButton);
export default __webpack_public_path__ + "static/media/alertsButton.6e3063fcada6e7a0ca8a147b2909b599.svg";
export { ForwardRef as ReactComponent };